export const CLOUDNAME = 'videoapi-demo';
export const BASENAME = 'video-demo';
